/**
 * SplitManaCost - Renders mana costs for split/adventure/DFC cards
 *
 * If the cost string contains "//", splits and renders each half as a ManaCost
 * with a styled separator. Otherwise delegates to plain ManaCost.
 */
import type { ReactElement } from 'react';

import type { ManaSymbolProps } from './ManaSymbol';
import { ManaCost } from './ManaSymbol';

export interface SplitManaCostProps {
  /** Mana cost string, e.g. "{2}{G} // {3}{G}{G}" or "{2}{W}{U}" */
  cost: string;
  /** Add drop shadow to mana symbols */
  shadow?: boolean;
  /** Desired visible height of each icon pill in px */
  iconSize?: number;
  /** Size multiplier */
  size?: ManaSymbolProps['size'];
}

export default function SplitManaCost({ cost, shadow = true, iconSize, size }: SplitManaCostProps): ReactElement {
  if (cost.includes('//')) {
    const faces = cost.split('//').map((face) => face.trim());
    return (
      <span className="inline-flex items-center gap-1">
        <ManaCost cost={faces[0]} shadow={shadow} iconSize={iconSize} size={size} />
        <span className="text-ash">//</span>
        <ManaCost cost={faces[1]} shadow={shadow} iconSize={iconSize} size={size} />
      </span>
    );
  }

  return <ManaCost cost={cost} shadow={shadow} iconSize={iconSize} size={size} />;
}
